import './ShopsAccordeonList.css';
import {GoogleMap} from '../../shops/google-map';

class ShopsAccordeonList {
  constructor(props) {
    this.root = props.root || null;
  }

  init() {
    let self = this;

    // инициализация карты
    GoogleMap.init().then(google => {
      [].slice.apply(this.root.querySelectorAll('.shop_map_js')).map(node => {
        self.initMap(google, node);
      });
    });

    // события
    this.root.addEventListener('click', event => {
      let target = event.target;

      let parentNode = target.closest('.accordeon_item');

      // показ / скрытие блока доп инфо
      if (target.classList.contains('accordeon_head') ||
          target.closest('.accordeon_head') instanceof HTMLElement) {
        parentNode.classList.toggle('expanded');
      } else if (target.classList.contains('inner__content__link')) { // клик по смене показа данных
        let destination = parentNode.querySelector(target.dataset.qs);
        let total_links = [].slice.apply(
            parentNode.querySelectorAll('.inner__content__link'));
        let total_blocks = [].slice.apply(
            parentNode.querySelectorAll('[data-switch="block"]'));

        total_links.forEach(link => {
          link.classList.toggle('selected');
        });

        total_blocks.forEach(block => {
          block.classList.toggle('hidden');
        });
      }
    });
  }

  initMap(google, node) {
    let map = new google.maps.Map(node, {disableDefaultUI: true});
    let marker = new google.maps.Marker({
      map: map,
      icon: '/local/templates/tehnoezh-modern/images/map-marker.svg',
    });

    map.setCenter({
      lat: +node.getAttribute('data-lat'),
      lng: +node.getAttribute('data-lng'),
    });
    map.setZoom(17);
    marker.setPosition({
      lat: +node.getAttribute('data-lat'),
      lng: +node.getAttribute('data-lng'),
    });
  }
}

export default ShopsAccordeonList;